// @flow
export const SET_PLAYLIST = 'Playlist/SET_PLAYLIST';
export const CLEAR_PLAYLIST = 'Playlist/CLEAR_PLAYLIST';
export const MARK_ITEM_AS_DOWNLOADING = 'Playlist/MARK_ITEM_AS_DOWNLOADING';
export const SET_PLAYLIST_TO_GO_BACK = 'Playlist/SET_PLAYLIST_TO_GO_BACK';
export const CLEAR_PLAYLIST_TO_GO_BACK = 'Playlist/CLEAR_PLAYLIST_TO_GO_BACK';

export const UPDATE_AVAILABLE_OFFLINE_START = 'Playlist/UPDATE_AVAILABLE_OFFLINE_START';
export const UPDATE_AVAILABLE_OFFLINE_SUCCESS = 'Playlist/UPDATE_AVAILABLE_OFFLINE_SUCCESS';
export const UPDATE_AVAILABLE_OFFLINE_FAILED = 'Playlist/UPDATE_AVAILABLE_OFFLINE_FAILED';
export const SET_FAVOURITE_PLAYLIST = 'Playlist/SET_FAVOURITE_PLAYLIST';


export function clearPlaylist() {
    return {
        type: CLEAR_PLAYLIST
    };
}

export function setPlaylist( playlist ) {
    return {
        playlist: playlist,
        type: SET_PLAYLIST
    };
}

export function setFavouritePlaylist( isFav ) {
    return {
        isFav: isFav,
        type: SET_FAVOURITE_PLAYLIST
    }
}

export function markItemAsDownloading( id, isDownloading, playlist ) {
    return {
        id: id,
        isDownloading: isDownloading,
        playlist: playlist,
        type: MARK_ITEM_AS_DOWNLOADING
    };
}

export function clearPlaylistToGoBack() {
    return {
        type: CLEAR_PLAYLIST_TO_GO_BACK
    };
}

export function setPlaylistToGoBack( playlist ) {
    return {
        playlist: playlist,
        type: SET_PLAYLIST_TO_GO_BACK
    };
}